<template>
  <div class="multiplos-servicos-add">
    <load v-if="loadingFamilia" message="Carregando..." />
    <div class="row" v-else>
      <header-servico
        tipo="Múltiplos Serviços"
        :loading="false"
        :familia="familia.id"
      />
      <div class="col-md-12">
        <div class="row">
          <sidebar-servicos :active="'multiplos-servicos'" />
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-12">
                <header-familia :item="familia" />
              </div>
            </div>

            <form @submit.prevent="submit(false)" ref="addItem">
              <div class="card border-0 shadow-sm mb-4">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-start flex-wrap mb-3"
                  >
                    <div>
                      <h2 class="h5 mb-1 text-gray-800">
                        1. Selecione os tipos para este atendimento
                      </h2>
                      <small class="text-muted">
                        Escolha um ou mais tipos para registrar neste
                        atendimento integrado.
                      </small>
                    </div>
                    <span class="badge badge-success-light mt-2 mt-md-0">
                      {{ tiposSelecionados.length }} tipo(s) selecionado(s)
                    </span>
                  </div>

                  <div class="row service-type-grid">
                    <div
                      v-for="tipo in tiposDisponiveis"
                      :key="tipo.key"
                      class="col-md-4 col-xl mb-3"
                    >
                      <button
                        type="button"
                        class="service-type-card w-100"
                        :class="{ active: isTipoSelecionado(tipo.key) }"
                        @click="toggleTipo(tipo.key)"
                      >
                        <span class="service-type-check">
                          <i
                            :class="
                              isTipoSelecionado(tipo.key) ? 'mdi mdi-check' : ''
                            "
                          />
                        </span>
                        <i :class="tipo.icon" class="service-type-icon" />
                        <strong class="small">{{ tipo.label }}</strong>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-body">
                  <h2 class="h5 mb-2 text-gray-800">
                    2. Dados comuns do atendimento
                  </h2>

                  <div class="alert alert-primary py-2 mb-3">
                    <i class="mdi mdi-information-outline mr-1" />
                    Os dados comuns serão compartilhados entre todos os tipos
                    selecionados. Preencha abaixo apenas as informações gerais
                    da interação.
                  </div>

                  <div class="row">
                    <form-select
                      v-model="dadosComuns.pessoas"
                      :multiple="true"
                      label="Usuário(s)"
                      :itens="pessoas"
                      :required="true"
                    />

                    <form-calendar
                      v-model="dadosComuns.data_atendimento"
                      grid="4"
                      label="Data do Atendimento"
                      :required="true"
                      ajuda="Data em que a interação foi realizada"
                      :max-date="dataNow"
                    />

                    <form-select
                      v-model="dadosComuns.unidade_id"
                      label="Unidade"
                      grid="4"
                      :itens="unidades"
                      :loading="loading.unidades"
                      :disabled="loading.unidades"
                      :required="true"
                    />
                  </div>

                  <search-tecnico :tecnicos.sync="dadosComuns.tecnicos" />

                  <div class="row">
                    <form-textarea-editor
                      v-model="dadosComuns.descricao_geral"
                      grid="12"
                      label="Descrição geral do atendimento"
                      :required="true"
                    />

                    <form-file
                      @submit="submitFile"
                      multiple
                      btn-text="Iniciar"
                      :progress="progressCompleted"
                    />

                    <form-toggle
                      grid="3"
                      class="mt-4"
                      v-model="dadosComuns.privado"
                      label="Sigilo?"
                    />
                  </div>
                </div>
              </div>

              <div class="card border-0 shadow-sm mb-4">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-start flex-wrap mb-3"
                  >
                    <div>
                      <h2 class="h5 mb-1 text-gray-800">
                        3. Detalhes por tipo selecionado
                      </h2>
                      <small class="text-muted">
                        Preencha somente os campos específicos dos tipos
                        escolhidos acima.
                      </small>
                    </div>
                    <div class="mt-2 mt-md-0">
                      <button
                        class="btn btn-link btn-sm"
                        type="button"
                        @click="setAllPanels(true)"
                      >
                        <i class="mdi mdi-arrow-expand-vertical" /> Expandir
                        todos
                      </button>
                      <button
                        class="btn btn-link btn-sm"
                        type="button"
                        @click="setAllPanels(false)"
                      >
                        <i class="mdi mdi-arrow-collapse-vertical" /> Recolher
                        todos
                      </button>
                    </div>
                  </div>

                  <div
                    v-if="tiposSelecionados.length < 2"
                    class="alert alert-warning mb-0"
                  >
                    Selecione pelo menos dois tipos de serviço para continuar.
                  </div>

                  <div
                    v-else
                    v-for="tipo in tiposSelecionadosOrdenados"
                    :key="tipo.key"
                    class="service-panel mb-3"
                  >
                    <button
                      class="service-panel-header"
                      type="button"
                      @click="togglePanel(tipo.key)"
                    >
                      <span>
                        <i :class="tipo.icon" class="mr-2" />
                        {{ tipo.label }}
                      </span>
                      <i
                        :class="
                          panels[tipo.key]
                            ? 'mdi mdi-chevron-up'
                            : 'mdi mdi-chevron-down'
                        "
                      />
                    </button>

                    <div v-show="panels[tipo.key]" class="service-panel-body">
                      <div v-if="tipo.key === 'atendimento'" class="row">
                        <form-select
                          v-model="atendimento.local"
                          label="Local"
                          grid="6"
                          :itens="$root.arrays.atendimento_local"
                          :required="true"
                        />
                        <form-select
                          v-model="atendimento.tipo_id"
                          label="Tipo"
                          grid="6"
                          :itens="tiposAtendimento"
                          :loading="loading.atendimentoCampos"
                          :disabled="loading.atendimentoCampos"
                          :required="true"
                        />
                        <form-select
                          v-model="atendimento.outra_unidade_id"
                          label="Outra Unidade"
                          grid="12"
                          :itens="outrasunidades"
                          v-if="atendimento.local == 4"
                        />
                        <form-input
                          v-if="atendimento.outra_unidade_id == 9999"
                          v-model="atendimento.outra_unidade_nome"
                          grid="12"
                          label="Digite o nome da outra Unidade"
                          :required="true"
                        />
                        <form-select
                          v-if="verificarTipo(atendimento.tipo_id, 'DENÚNCIA')"
                          v-model="atendimento.denuncia_id"
                          label="Denúncia(s)"
                          :multiple="true"
                          :itens="denuncias"
                          :loading="loading.atendimentoCampos"
                          :disabled="loading.atendimentoCampos"
                        />
                        <form-select
                          v-if="
                            verificarTipo(
                              atendimento.tipo_id,
                              'ABORDAGEM SOCIAL'
                            )
                          "
                          v-model="atendimento.situacao_abordagem_social"
                          grid="12"
                          label="Situação Identificada na Abordagem Social"
                          :itens="$root.arrays.situacao_abordagem_social"
                          :required="true"
                          @change="verficaAbordagem"
                          :multiple="true"
                        />
                        <form-select
                          v-model="atendimento.tipo_servico_id"
                          label="Serviço"
                          grid="12"
                          :itens="servicosAtendimento"
                          :loading="loading.atendimentoCampos"
                          :disabled="loading.atendimentoCampos"
                        />
                        <form-input
                          v-if="campoExtra"
                          v-model="atendimento.outra_situacao_abordagem_social"
                          grid="12"
                          label="Digite a outra Situação Identificada na Abordagem Social"
                          :required="true"
                        />
                        <div
                          class="col-md-6"
                          v-if="
                            verificarTipo(
                              atendimento.tipo_id,
                              'ESCUTA ESPECIALIZADA'
                            )
                          "
                        >
                          <form-toggle
                            label="A Ficha SINAN foi preenchida?"
                            v-model="atendimento.ficha_sinan"
                            ajuda="Caso o profissional opte pelo preenchimento, poderá acessá-la pelo portal SINAN federal. Link: https://portalsinan.saude.gov.br/images/documentos/Agravos/via/violencia_v5.pdf"
                          />
                          <div class="row">
                            <div class="col-auto">Não</div>
                            <div class="col-auto">Sim</div>
                          </div>
                        </div>
                        <form-textarea-editor
                          v-model="atendimento.descricao_sumaria"
                          grid="12"
                          label="Descrição sumária do atendimento"
                          :required="true"
                        />
                        <form-select
                          v-model="atendimento.vulnerabilidades"
                          label="Vulnerabilidades"
                          :multiple="true"
                          :itens="vulnerabilidades"
                          :loading="loading.atendimentoCampos"
                          :disabled="loading.atendimentoCampos"
                          :append-to-body="true"
                        />
                        <form-select
                          v-model="atendimento.status"
                          label="Status"
                          grid="4"
                          :itens="statusAtendimento"
                          :loading="loading.atendimentoCampos"
                          :disabled="loading.atendimentoCampos"
                          :required="true"
                          :append-to-body="true"
                        />
                      </div>

                      <div v-if="tipo.key === 'beneficios'">
                        <div class="alert alert-info" v-if="showMsgQtd">
                          Notamos que o Benefício selecionado não possui
                          quantidade suficiente para esta concessão. Após o
                          cadastro o Gestor(a) será notificado e avaliará a
                          solicitação.
                        </div>

                        <div class="row">
                          <form-select
                            v-model="beneficio.usuario_id"
                            label="Usuário(s)"
                            :itens="pessoas"
                            :required="true"
                          />
                          <form-select
                            v-model="beneficio.beneficio_id"
                            label="Benefício"
                            :itens="beneficios"
                            :required="true"
                            :disabled="loading.beneficios"
                            :loading="loading.beneficios"
                            :grid="!disabledQtd ? '8' : '12'"
                            ajuda="Se o Benefício que você deseja liberar não for encontrado nas opções abaixo você deve cadastra  na página de gestão de benefícios ou solicitar o cadastro a quem tem permissões para realizar a ação"
                          />
                          <form-input
                            v-model="beneficio.valor"
                            label="Valor"
                            grid="5"
                            type="text"
                            inputGroup="true"
                            btnText="R$"
                            @input="formatarValorBeneficio"
                            :disabled="disabledValor"
                            v-if="!disabledValor"
                          />
                          <form-input
                            v-model="beneficio.quantidade"
                            label="Quantidade"
                            grid="4"
                            type="number"
                            :required="true"
                            :disabled="disabledQtd"
                            :min="1"
                            v-if="!disabledQtd"
                          />
                          <form-select
                            v-model="beneficio.periodicidade"
                            label="Periodicidade"
                            grid="3"
                            :itens="$root.arrays.beneficio_periodicidade"
                          />
                          <form-select
                            v-model="beneficio.solicitante"
                            label="Solicitante"
                            grid="3"
                            :itens="$root.arrays.solicitante"
                            :required="true"
                          />
                          <form-input
                            v-model="beneficio.nome_solicitante"
                            label="Nome do Solicitante"
                            grid="6"
                            :required="true"
                            :disabled="
                              beneficio.solicitante == 1 ? true : false
                            "
                          />
                          <form-textarea-editor
                            v-model="beneficio.observacoes"
                            grid="12"
                            label="Observação"
                          />
                          <form-textarea-editor
                            v-model="beneficio.parecer_tecnico"
                            grid="12"
                            label="Parecer Técnico"
                          />
                          <form-select
                            v-model="beneficio.status_parecer"
                            label="Status do Parecer"
                            grid="12"
                            :itens="$root.arrays.status_parecer"
                            :required="true"
                            :append-to-body="true"
                          />
                        </div>
                      </div>

                      <div v-if="tipo.key === 'encaminhamento'" class="row">
                        <form-select
                          v-model="encaminhamento.tipo_id"
                          label="Tipo de Encaminhamento"
                          :itens="tiposEncaminhamento"
                          :loading="loading.tiposEncaminhamento"
                          :disabled="loading.tiposEncaminhamento"
                          :required="true"
                        />
                        <form-toggle
                          grid="4"
                          class="mt-4"
                          v-model="encaminhamento.unidade_externa"
                          label="Para Unidade Externa?"
                        />
                        <form-select
                          v-model="encaminhamento.unidade_destino_id"
                          label="Unidade de Destino"
                          grid="8"
                          :itens="unidadesDestino"
                          :loading="loading.unidadesDestino"
                          :disabled="loading.unidadesDestino"
                          :required="true"
                          @change="getTecnicosDestino"
                        />
                        <form-select
                          v-model="funcaoSelecionada"
                          label="Selecione uma Função"
                          grid="6"
                          :itens="funcoesDestino"
                          :loading="loading.funcoesDestino"
                          :disabled="loading.funcoesDestino"
                          @change="filtrarTecnicosPorFuncao"
                        />
                        <form-select
                          v-model="encaminhamento.user_destino_id"
                          label="Destinatário"
                          grid="6"
                          :itens="tecnicosDestinoFiltrados"
                          :loading="loading.tecnicosDestino"
                          :disabled="loading.tecnicosDestino"
                        />
                        <form-textarea-editor
                          v-model="encaminhamento.descricao_sumaria"
                          grid="12"
                          label="Descrição sumária do encaminhamento"
                          :required="true"
                        />
                        <form-toggle
                          grid="5"
                          class="mt-4"
                          v-model="showScheduling"
                          label="Deseja realizar uma solicitação de agendamento?"
                        />
                        <template v-if="showScheduling">
                          <form-calendar
                            v-model="encaminhamentoAgendamento.data_prevista"
                            grid="4"
                            label="Data do Agendamento"
                            :min-date="dataNow"
                            :required="true"
                          />
                          <form-calendar
                            v-model="encaminhamentoAgendamento.hora_prevista"
                            grid="4"
                            label="Hora do Agendamento"
                            mode="time"
                            :required="true"
                          />
                          <form-textarea-editor
                            v-model="encaminhamentoAgendamento.descricao"
                            grid="12"
                            label="Descrição do Agendamento"
                          />
                        </template>
                      </div>

                      <div v-if="tipo.key === 'programa_social'" class="row">
                        <form-select
                          v-model="programaSocial.pessoas"
                          :multiple="true"
                          label="Usuário(s)"
                          :itens="pessoas"
                          :required="true"
                        />

                        <form-select
                          v-model="programaSocial.programa_social_id"
                          label="Programa Social"
                          :itens="programasSociais"
                          :loading="loading.programasSociais"
                          :disabled="loading.programasSociais"
                          :required="true"
                          @input="setValorProgramaSocial"
                          ajuda="Se o item que você procura não for encontrado nas opções abaixo você deve cadastrar na página de gestão de Programas Sociais ou solicitar o cadastro a quem tem permissões para realizar a ação"
                        />

                        <form-calendar
                          v-model="programaSocial.data_inicial"
                          grid="2"
                          label="Data de Início"
                          :required="true"
                        />

                        <form-calendar
                          v-model="programaSocial.data_final"
                          grid="2"
                          label="Data de Final"
                        />

                        <form-input
                          v-model="programaSocial.valor"
                          grid="4"
                          inputGroup="true"
                          btnText="R$"
                          :type="'number'"
                          label="Valor"
                        />

                        <form-textarea-editor
                          v-model="programaSocial.descricao"
                          grid="12"
                          label="Situação Identificada"
                          :required="true"
                        />
                      </div>

                      <div v-if="tipo.key === 'violacao_direitos'" class="row">
                        <form-select
                          v-model="violacaoDireitos.vitimas"
                          :multiple="true"
                          label="Vítima(s)"
                          :itens="pessoas"
                          :required="true"
                        />
                        <form-select
                          v-model="violacaoDireitos.violacoes"
                          :multiple="true"
                          label="Violação de Direitos"
                          :itens="tiposViolacaoDireitos"
                          :loading="loading.tiposViolacaoDireitos"
                          :disabled="loading.tiposViolacaoDireitos"
                          :required="true"
                        />
                        <form-toggle
                          grid="4"
                          class="mt-4"
                          v-model="violacaoDireitos.acompanhamento"
                          label="Acompanhamento"
                        />
                        <form-textarea-editor
                          v-model="violacaoDireitos.descricao"
                          grid="12"
                          label="Descrição da situação de violação de direitos e suas supostas motivações"
                          :required="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-2 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                  <a class="btn btn-default mr-2" @click="$emit('voltar')">
                    <i class="mdi mdi-arrow-left" />
                    Cancelar
                  </a>
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                    :disabled="tiposSelecionados.length < 2"
                  >
                    <i class="mdi mdi-content-save" />
                    Salvar atendimento e registros
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["morph"],
  name: "AddMultiplosServicos",
  data() {
    return {
      familia: {},
      loadingFamilia: true,
      tiposSelecionados: ["atendimento"],
      panels: {
        atendimento: true,
        beneficios: true,
        encaminhamento: true,
        programa_social: true,
        violacao_direitos: true,
      },
      pessoas: [],
      tiposDisponiveis: [
        {
          key: "atendimento",
          label: "Atendimento",
          icon: "mdi mdi-account-tie",
        },
        {
          key: "beneficios",
          label: "Benefício",
          icon: "mdi mdi-hand-heart-outline",
        },
        {
          key: "encaminhamento",
          label: "Encaminhamento",
          icon: "mdi mdi-arrow-right-bold",
        },
        {
          key: "programa_social",
          label: "Programa Social",
          icon: "mdi mdi-heart-outline",
        },
        {
          key: "violacao_direitos",
          label: "Violação de Direitos",
          icon: "mdi mdi-account-alert-outline",
        },
      ],
      dadosComuns: {
        pessoas: [],
        data_atendimento: moment().format("YYYY-MM-DD"),
        unidade_id: null,
        tecnicos: [],
        descricao_geral: "",
        privado: 2,
      },
      atendimento: {
        local: null,
        tipo_id: null,
        outra_unidade_id: null,
        outra_unidade_nome: "",
        denuncia_id: [],
        situacao_abordagem_social: [],
        tipo_servico_id: null,
        outra_situacao_abordagem_social: "",
        ficha_sinan: 2,
        vulnerabilidades: [],
        status: null,
        descricao_sumaria: "",
      },
      beneficio: {
        usuario_id: null,
        beneficio_id: null,
        valor: "",
        quantidade: null,
        periodicidade: null,
        solicitante: null,
        nome_solicitante: "",
        observacoes: "",
        parecer_tecnico: "",
        status_parecer: null,
        situacao: "",
      },
      encaminhamento: {
        tipo_id: null,
        unidade_externa: 0,
        unidade_destino_id: null,
        user_destino_id: null,
        descricao_sumaria: "",
        privado: 2,
      },
      encaminhamentoAgendamento: {
        data_prevista: "",
        hora_prevista: "",
        descricao: "",
      },
      programaSocial: {
        pessoas: [],
        programa_social_id: null,
        data_inicial: "",
        data_final: "",
        valor: "",
        descricao: "",
      },
      violacaoDireitos: {
        vitimas: [],
        violacoes: [],
        acompanhamento: 0,
        descricao: "",
        tecnicos: [],
      },
      unidades: [],
      outrasunidades: [],
      unidadesDestino: [],
      tiposAtendimento: [],
      servicosAtendimento: [],
      statusAtendimento: [],
      vulnerabilidades: [],
      denuncias: [],
      beneficios: [],
      tiposEncaminhamento: [],
      tecnicosDestino: [],
      tecnicosDestinoFiltrados: [],
      funcoesDestino: [],
      funcaoSelecionada: null,
      programasSociais: [],
      tiposViolacaoDireitos: [],
      files: [],
      progressCompleted: 0,
      showScheduling: false,
      campoExtra: false,
      disabledQtd: true,
      showMsgQtd: false,
      disabledValor: true,
      dataNow: moment().format("YYYY-MM-DD"),
      loading: {
        atendimentoCampos: false,
        unidades: false,
        unidadesDestino: false,
        tiposAtendimento: false,
        servicosAtendimento: false,
        statusAtendimento: false,
        vulnerabilidades: false,
        beneficios: false,
        tiposEncaminhamento: false,
        tecnicosDestino: false,
        funcoesDestino: false,
        programasSociais: false,
        tiposViolacaoDireitos: false,
      },
    };
  },
  computed: {
    tiposSelecionadosOrdenados() {
      return this.tiposDisponiveis.filter((tipo) =>
        this.tiposSelecionados.includes(tipo.key)
      );
    },
  },
  watch: {
    "beneficio.beneficio_id": function (val) {
      this.disabledQtd = this.beneficios.some(
        (item) => item.qtd === true && val == item.id
      )
        ? false
        : true;

      this.disabledValor = this.beneficios.some(
        (item) => item.categoria === 1 && val == item.id
      )
        ? false
        : true;

      if (this.disabledQtd) {
        this.beneficio.quantidade = null;
        this.showMsgQtd = false;
      }

      if (this.disabledValor) {
        this.beneficio.valor = "";
      }
    },
    "beneficio.quantidade": function (val) {
      if (!this.disabledQtd) {
        this.showMsgQtd = this.beneficios.some(
          (item) =>
            item.qtd === true &&
            item.id == this.beneficio.beneficio_id &&
            item.quantidade_disponivel < val
        );
      }
    },
    "encaminhamento.unidade_externa": function () {
      this.encaminhamento.unidade_destino_id = null;
      this.encaminhamento.user_destino_id = null;
      this.funcaoSelecionada = null;
      this.getUnidadesDestino();
    },
  },
  mounted() {
    this.getCamposIniciais();
    this.getFamilia();
  },
  methods: {
    getFamilia() {
      this.loadingFamilia = true;

      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;

          this.pessoas = this.familia.familiares
            .filter((elem) => elem.estado_cadastral_cadunico <= 3)
            .map((elem) => ({
              id: elem.id,
              value: elem.nome_social
                ? `${elem.nome_social} <b>${elem.idade} ano(s)</b>`
                : `${elem.nome_completo} <b>${elem.idade} ano(s)</b>`,
            }));

            this.loadingFamilia = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    isTipoSelecionado(tipo) {
      return this.tiposSelecionados.includes(tipo);
    },
    toggleTipo(tipo) {
      if (this.isTipoSelecionado(tipo)) {
        this.tiposSelecionados = this.tiposSelecionados.filter(
          (item) => item !== tipo
        );
        return;
      }

      this.tiposSelecionados.push(tipo);
      this.$set(this.panels, tipo, true);
    },
    togglePanel(tipo) {
      this.$set(this.panels, tipo, !this.panels[tipo]);
    },
    setAllPanels(opened) {
      this.tiposDisponiveis.forEach((tipo) => {
        this.$set(this.panels, tipo.key, opened);
      });
    },
    submitFile(files) {
      this.files = files;
    },
    verficaAbordagem(value) {
      this.campoExtra = Array.isArray(value) && value.indexOf(6) >= 0;
    },
    verificarTipo(tipo, search) {
      const result = this.tiposAtendimento.filter(
        (item) => item.id == tipo && item.value == search
      );

      return result.length > 0;
    },
    getCamposIniciais() {
      this.getInformacaoCampos();
      this.getUnidadesDestino();
      this.getBeneficios();
      this.getTiposEncaminhamento();
      this.getProgramasSociais();
      this.getTiposViolacaoDireitos();
    },
    requestOptions(url, target, loadingKey) {
      this.loading[loadingKey] = true;

      return axios
        .get(url)
        .then((response) => {
          this[target] = Array.isArray(response.data)
            ? response.data
            : response.data.data || [];
        })
        .catch(() => {
          this[target] = [];
        })
        .finally(() => {
          this.loading[loadingKey] = false;
        });
    },
    setAtendimentoCamposLoading(value) {
      this.loading.atendimentoCampos = value;
      this.loading.unidades = value;
      this.loading.tiposAtendimento = value;
      this.loading.servicosAtendimento = value;
      this.loading.statusAtendimento = value;
      this.loading.vulnerabilidades = value;
    },
    getInformacaoCampos() {
      this.setAtendimentoCamposLoading(true);

      return axios
        .get(`api/dashboard/atendimento/get/imformacao/campo`)
        .then((response) => {
          const unidades = response.data.unidades || [];

          this.vulnerabilidades = response.data.vunerabilidades || [];
          this.tiposAtendimento = response.data.tipos || [];
          this.denuncias = response.data.denuncias || [];
          this.servicosAtendimento = response.data.servicos || [];
          this.unidades = unidades;
          this.outrasunidades = Array.isArray(unidades) ? unidades.slice() : [];
          this.outrasunidades.push({
            id: 9999,
            value: "Outra",
          });
          this.statusAtendimento = response.data.status || [];
        })
        .finally(() => {
          this.setAtendimentoCamposLoading(false);
        });
    },
    getUnidadesDestino() {
      const tipo = this.encaminhamento.unidade_externa
        ? "UE - UNIDADE EXTERNA"
        : "";

      return this.requestOptions(
        `api/dashboard/unidades/get/externas/${tipo}`,
        "unidadesDestino",
        "unidadesDestino"
      );
    },
    getBeneficios() {
      return this.requestOptions(
        "api/dashboard/get/beneficios",
        "beneficios",
        "beneficios"
      );
    },
    getTiposEncaminhamento() {
      return this.requestOptions(
        "api/dashboard/encaminhamento/tipos",
        "tiposEncaminhamento",
        "tiposEncaminhamento"
      );
    },
    getProgramasSociais() {
      return this.requestOptions(
        "api/dashboard/get/programassociais",
        "programasSociais",
        "programasSociais"
      );
    },
    setValorProgramaSocial(value) {
      this.programasSociais.forEach((item) => {
        if (value == item.id && item.valor != null) {
          this.programaSocial.valor = item.valor;
        } else if (value == item.id) {
          this.programaSocial.valor = "";
        }
      });
    },
    getTiposViolacaoDireitos() {
      return this.requestOptions(
        "api/dashboard/violacaodedireitos/tipos",
        "tiposViolacaoDireitos",
        "tiposViolacaoDireitos"
      );
    },
    getTecnicosDestino(unidadeId) {
      if (!unidadeId) {
        this.tecnicosDestino = [];
        this.tecnicosDestinoFiltrados = [];
        this.funcoesDestino = [];
        return;
      }

      this.loading.tecnicosDestino = true;
      this.loading.funcoesDestino = true;

      axios
        .get(`api/dashboard/tecnicos/get/externos/${unidadeId}`)
        .then((response) => {
          this.tecnicosDestino = response.data;
          this.tecnicosDestinoFiltrados = response.data;
          this.funcoesDestino = response.data
            .map((tecnico) => ({ id: tecnico.role, value: tecnico.role }))
            .filter((obj, index, self) => {
              return (
                obj.id !== "Admin" &&
                index === self.findIndex((item) => item.id === obj.id)
              );
            });
        })
        .finally(() => {
          this.loading.tecnicosDestino = false;
          this.loading.funcoesDestino = false;
        });
    },
    filtrarTecnicosPorFuncao() {
      this.encaminhamento.user_destino_id = null;

      if (!this.funcaoSelecionada) {
        this.tecnicosDestinoFiltrados = this.tecnicosDestino;
        return;
      }

      this.tecnicosDestinoFiltrados = this.tecnicosDestino.filter(
        (tecnico) => tecnico.role === this.funcaoSelecionada
      );
    },
    formatarValorBeneficio() {
      if (!this.beneficio.valor) {
        return;
      }

      let valor = this.beneficio.valor.replace(/\D/g, "");

      if (valor.length > 2) {
        valor = valor.replace(/(\d)(\d{2})$/, "$1,$2");
      }
      if (valor.length > 6) {
        valor = valor.replace(/(\d)(\d{3})(\d{3})$/, "$1.$2.$3");
      }

      this.beneficio.valor = valor;
    },
    formatarValorParaSubmit(valorFormatado) {
      if (!valorFormatado) {
        return null;
      }

      return String(valorFormatado).replace(/\./g, "").replace(",", ".");
    },
    verificaCategoria(value) {
      const response = this.beneficios.find((elem) => elem.id == value);
      return response && response.categoria === 1 ? 1 : 2;
    },
    buildPayload(rascunho) {
      return {
        familia_id: this.$route.query.familia_id,
        morph: this.morph,
        rascunho: rascunho ? 1 : 0,
        tipos_selecionados: this.tiposSelecionados,
        dados_comuns: this.dadosComuns,
        atendimento: this.isTipoSelecionado("atendimento")
          ? this.atendimento
          : null,
        beneficio: this.isTipoSelecionado("beneficios")
          ? {
              ...this.beneficio,
              valor: this.formatarValorParaSubmit(this.beneficio.valor),
            }
          : null,
        encaminhamento: this.isTipoSelecionado("encaminhamento")
          ? this.encaminhamento
          : null,
        encaminhamento_agendamento:
          this.isTipoSelecionado("encaminhamento") && this.showScheduling
            ? this.encaminhamentoAgendamento
            : null,
        programa_social: this.isTipoSelecionado("programa_social")
          ? this.programaSocial
          : null,
        violacao_direitos: this.isTipoSelecionado("violacao_direitos")
          ? this.violacaoDireitos
          : null,
      };
    },
    appendPayloadToFormData(formData, payload) {
      Object.keys(payload).forEach((key) => {
        if (payload[key] === null || payload[key] === undefined) {
          return;
        }

        if (typeof payload[key] === "object") {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        formData.append(key, payload[key]);
      });
    },
    submit(rascunho) {
      if (this.tiposSelecionados.length < 2) {
        swal.fire({
          title: "Selecione pelo menos dois tipos de serviço",
          icon: "warning",
        });
        return;
      }

      const formData = new FormData();
      this.appendPayloadToFormData(formData, this.buildPayload(rascunho));

      if (this.files.length > 0 && this.files.length !== undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("anexos[]", this.files[i]);
        }
      }

      const buttonSelector = rascunho ? ".btn-draft" : ".btn-submit";
      const ladda = Ladda.create(document.querySelector(buttonSelector));
      ladda.start();

      axios
        .post("api/dashboard/familia/multiplos-servicos", formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            this.progressCompleted = Math.round(
              (event.loaded * 100) / event.total
            );
          },
        })
        .then((response) => {
          this.$snack.success({
            button: false,
            text:
              response.data.data && response.data.data.message
                ? response.data.data.message
                : "Registro salvo com sucesso.",
          });

          if (this.morph !== undefined) {
            this.$emit("reload");
            return;
          }

          const id = response.data.data ? response.data.data.id : null;
          if (id) {
            this.$router.push(
              `/dashboard/atendimentos/${this.$route.query.familia_id}`
            );
          }
        })
        .finally(() => {
          ladda.stop();
          this.progressCompleted = 0;
          this.files = [];
        });
    },
  },
};
</script>

<style scoped>
.multiplos-servicos-add .card {
  border-radius: 2px;
}

.badge-success-light {
  background: #e7f7ec;
  border: 1px solid #bde7c8;
  color: #22914a;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 10px;
}

.service-type-grid .col-xl {
  min-width: 180px;
}

.service-type-card {
  position: relative;
  min-height: 118px;
  border: 1px solid #e1e6ef;
  border-radius: 4px;
  background: #fff;
  color: #3f4854;
  padding: 18px 12px 14px;
  text-align: center;
  transition: all 0.15s ease-in-out;
}

.service-type-card:hover {
  border-color: #5a95f5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.service-type-card.active {
  border-color: #4f8df7;
  background: #f7faff;
}

.service-type-check {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 18px;
  height: 18px;
  border: 1px solid #c8d2df;
  border-radius: 3px;
  color: #fff;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.service-type-card.active .service-type-check {
  background: #4f8df7;
  border-color: #4f8df7;
}

.service-type-icon {
  display: block;
  color: #2f3a4a;
  font-size: 24px;
  margin-bottom: 8px;
}

.service-type-card strong,
.service-type-card small {
  display: block;
}

.service-type-card small {
  color: #6c757d;
  font-size: 11px;
  line-height: 1.35;
  margin-top: 5px;
}

.service-panel {
  border: 1px solid #b9d4fb;
  border-radius: 3px;
  overflow: visible;
}

.service-panel-header {
  width: 100%;
  border: 0;
  background: #eef6ff;
  color: #265fbd;
  font-weight: 600;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.service-panel-body {
  background: #fff;
  padding: 14px 12px 2px;
}

.alert-primary {
  color: #3174da;
  background: #f2f7ff;
  border-color: #9ac1ff;
  font-size: 12px;
}
</style>
